import { render, staticRenderFns } from "./viewEdit.vue?vue&type=template&id=120f8091&scoped=true&"
import script from "./viewEdit.vue?vue&type=script&lang=js&"
export * from "./viewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120f8091",
  null
  
)

export default component.exports